import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export interface Props {
  className?: string;
}

const RoundedRectangleSegments = (props: Props) => {
  const { className } = props;
  return (
    <SvgIcon
      className={className}
      viewBox="0 0 256 145"
      width="256"
      height="145"
    >
      <g>
        <path
          d="M252.585,-0C254.493,8.41 255.5,17.163 255.5,26.15C255.5,91.15 202.81,143.84 137.81,143.84L-0,143.84"
          strokeWidth="1"
          stroke="#000000"
          fill="none"
          strokeOpacity="1"
        />
        <path
          d="M222.111,-0C224.614,8.277 225.96,17.056 225.96,26.15C225.96,75.96 185.57,116.35 135.76,116.35L0,116.35"
          strokeWidth="1"
          stroke="#000000"
          fill="none"
          strokeOpacity="1"
        />
        <path
          d="M190.843,0C194.42,7.984 196.41,16.834 196.41,26.15C196.41,61.49 167.76,90.15 132.41,90.15L3.41,90.15C2.266,90.15 1.129,90.12 -0,90.061"
          strokeWidth="1"
          stroke="#000000"
          fill="none"
          strokeOpacity="1"
        />
      </g>
    </SvgIcon>
  );
};

export default RoundedRectangleSegments;
